import { ref, markRaw } from "vue";

const notification = {
  show: ref(false),
  type: ref("success"),
  title: ref(""),
  text: ref(""),
  timeout: ref(5000),
};

export const useNotification = () => {
  // Reset notification state
  const resetNotification = () => {
    notification.type.value = "success";
    notification.title.value = "";
    notification.text.value = "";
    notification.timeout.value = 5000;
  };

  // Display success notification
  const success = (text, title = "", timeout = 5000) => {
    resetNotification();
    notification.show.value = true;
    notification.type.value = "success";
    notification.title.value = title;
    notification.text.value = text;
    notification.timeout.value = timeout;
  };

  // Display error notification
  const error = (text, title = "", timeout = 5000) => {
    resetNotification();
    notification.show.value = true;
    notification.type.value = "error";
    notification.title.value = title;
    notification.text.value = text;
    notification.timeout.value = timeout;
  };

  // Display warning notification
  const warning = (text, title = "", timeout = 5000) => {
    resetNotification();
    notification.show.value = true;
    notification.type.value = "warning";
    notification.title.value = title;
    notification.text.value = text;
    notification.timeout.value = timeout;
  };

  // Display info notification
  const info = (text, title = "", timeout = 5000) => {
    resetNotification();
    notification.show.value = true;
    notification.type.value = "info";
    notification.title.value = title;
    notification.text.value = text;
    notification.timeout.value = timeout;
  };

  const plain = (text, timeout = 5000) => {
    resetNotification();
    notification.show.value = true;
    notification.type.value = "plain";
    notification.title.value = "";
    notification.text.value = text;
    notification.timeout.value = timeout;
  };

  // Close notification
  const close = () => {
    notification.show.value = false;
  };

  return {
    ...notification,
    success,
    error,
    warning,
    info,
    plain,
    close,
  };
};

export default {
  install: (app) => {
    app.config.globalProperties.$notify = markRaw({
      success: (text, title, timeout) =>
        useNotification().success(text, title, timeout),
      error: (text, title, timeout) =>
        useNotification().error(text, title, timeout),
      warning: (text, title, timeout) =>
        useNotification().warning(text, title, timeout),
      info: (text, title, timeout) =>
        useNotification().info(text, title, timeout),
      plain: (text, timeout) => useNotification().plain(text, timeout),
      close: () => useNotification().close(),
    });

    // Add a composable for use in setup
    app.provide("notify", useNotification());
  },
};
